export const getYear = state => state.reportTrailerCosts.getIn(['list', 'year'])

export const getData = state => state.reportTrailerCosts.getIn(['list', 'data'])
export const getFetching = state => state.reportTrailerCosts.getIn(['list', 'fetching'])
export const getError = state => state.reportTrailerCosts.getIn(['list', 'error'])

export const getDetailsData = state => state.reportTrailerCosts.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportTrailerCosts.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportTrailerCosts.getIn(['details', 'error'])
